/**
 * Resolve o catálogo de navegação compartilhado com o Admin.
 *
 * A configuração de runtime pode não estar disponível durante a inicialização
 * ou em testes; nesse caso, usa o mesmo catálogo adotado pelo hDocs.
 */
export function catalogoDeMenu(configuracao = globalThis.window?.appConfig) {
    return configuracao?.APPMENU_CATALOG || "hLiberty.LPBuilder";
}
